import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { IMediaTranscoderRepository } from "../../../domain/media-transcoder/media-transcoder.repository";

interface JobsTabChildComponent {
  vm?: {
    refreshJobs?: () => Promise<void>;
  };
}

@Component({
  selector: "media-transcoder-jobs",
  templateUrl: "./jobs.component.html",
  styleUrls: ["./jobs.component.scss"],
})
export class MediaTranscoderJobsComponent implements OnInit {
  showPackagerTab = false;

  @ViewChild(RouterOutlet)
  private outlet: RouterOutlet;

  constructor(
    private router: Router,
    private _mediaTranscoderRepository: IMediaTranscoderRepository,
  ) {}

  async ngOnInit(): Promise<void> {
    const sideEffects = await this._mediaTranscoderRepository.getSideEffects();
    this.showPackagerTab = sideEffects.length > 0;
  }

  reloadCurrentRoute(): void {
    const child = this.outlet?.component as JobsTabChildComponent | null;

    if (child?.vm?.refreshJobs) {
      void child.vm.refreshJobs();
      return;
    }

    const currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
}
